import "./headlineTextText.scss";

export default ({headline, copy}) => (
  <section>
    <div className="article-headlineTextText">
      <div className="headline">{headline}</div>
      <div className="copy">{copy}</div>
    </div>
  </section>
);
